<!-- ===================footer ================ -->
<footer>
    <div class="footer-bg ">
        <div class="cpt-6 cmb-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <div class="footer-sc">
                            <div class="bar-title">
                                <h3>Contact Us</h3>
                            </div>
                            <div class="footer-content">


                                <ul class="footer-ul">
                                    <li>
                                        <i class="icofont-location-pin"></i>
                                        <p>Plot No. 84/1, Phase I, GIDC, Vatva, Ahmedabad - 382445, Gujarat-India.</p>
                                    </li>

                                    <li>
                                        <i class="icofont-email"></i>
                                        <div class="contact-list">
                                            <p>sales&#64;prismtextilemachinery.com</p>
                                            <p>harshad&#64;prismtextilemachinery.com</p>
                                        </div>
                                    </li>

                                    <li>
                                        <i class="icofont-phone"></i>
                                        <div class="contact-list">
                                            <p>+919427363268</p>
                                            <p>+917929700170</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <div class="footer-sc">
                            <div class="bar-title">
                                <h3>Quick Links</h3>
                            </div>
                            <div class="footer-content">
                                <ul class="footer-ul">
                                    <li>
                                        <a routerLink="/" class="foot-link">Home</a>
                                    </li>
                                    <li>
                                        <a routerLink="/about-us" class="foot-link">Company</a>
                                    </li>
                                    <li>
                                        <a routerLink="/videos" class="foot-link">Videos</a>
                                    </li>
                                    <li>
                                        <a routerLink="/news" class="foot-link">News & Events</a>
                                    </li>
                                    <li>
                                        <a routerLink="/contact-us" class="foot-link">Contact Us</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <div class="footer-sc">
                            <div class="bar-title">
                                <h3>Certified By</h3>
                            </div>
                            <div class="footer-content">
                                <ul class="footer-ul">
                                    <li>
                                        <a href="javascript:void(0)" class="foot-link">
                                            ISO 9001 : 2008 Certified Company
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" class="foot-link">
                                            Registered Manufacturer for TUF - Scheme
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.itamma.com/" target="_blank" class="foot-link">
                                            Member of ITAMMA
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://ittaindia.org/our-members/" target="_blank" class="foot-link">
                                            Member of ITTA
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="footer-content">
                                <ul class="footer-ul">
                                    <li>
                                        <div class="latest-news">
                                            <img src="assets/img/blog/1.png" alt="Image not found">
                                            <div class="news-details">
                                                <a href="blog-details.html" class="news-title">How to
                                                    Prepare for your First his</a>
                                                <p>Jan 01, 2022</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="latest-news">
                                            <img src="assets/img/blog/2.png" alt="Image not found">
                                            <div class="news-details">
                                                <a href="blog-details.html" class="news-title">How to
                                                    Prepare for your First his</a>
                                                <p>Jan 01, 2022</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <div class="footer-sc">
                            <div class="bar-title">
                                <h3>Follow Us On</h3>
                            </div>
                            <div class="footer-content">
                                <div class="footer-socials">
                                    <ul>
                                        <li>
                                            <a href="https://www.facebook.com/Prism-Textile-Machinery-Pvt-Ltd-316908801691389"
                                                title="Follow on Facebook" target="_blank">
                                                <i class="icofont-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.youtube.com/@prismtextilemachinery"
                                                title="Subscribe on Youtube" target="_blank">
                                                <i class="icofont-youtube-play"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/in/prismtextilemachinery"
                                                title="Follow on Linkedin" target="_blank">
                                                <i class="icofont-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/prismtextile" title="Follow on Twitter"
                                                target="_blank">
                                                <i class="icofont-twitter"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="bar-title mt-4 pt-2">
                                <h3>Google Translate</h3>
                            </div>
                            <div class="mt-3">
                                <div id="google_translate_element"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                        <p class="mb-2">
                            Copyright &copy; {{currentYear}} <a href="https://www.prismtextilemachinery.com/"
                                target="_blank" class="theme-color fw-semibold">Prism Textile Machinery</a>.
                            All rights reserved. 
                            Powered by <a href="https://kaimsit.com/" target="_blank"
                                class="theme-color fw-semibold"> Kaims IT Services</a>
                        </p>
                        <ul id="menu-footer-menu" class="footer-nav-menu">
                            <li>
                                <a routerLink="/privacy" class="theme-color fw-semibold">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a routerLink="/terms" class="theme-color fw-semibold">
                                    Terms & Conditions
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- ===================footer end================ -->